import { messages as enMessages } from './en';
import { messages as nlMessages } from './nl';
export const translations = {
    en: enMessages,
    nl: nlMessages
};
export { enMessages, nlMessages };
// Export a function to get translations by locale
export const getTranslation = (locale = 'en') => {
    return translations[locale] || translations.en;
};
/**
 * Creates a translation function for the specified locale
 * @param locale The locale code (e.g., 'en', 'nl')
 * @returns A translation function that resolves keys and interpolates parameters
 */
export function createTranslator(locale = 'en') {
    // Get translations for the specified locale
    const translations = getTranslation(locale);
    // Create a translation function
    const t = (key, params = {}) => {
        // Split the key by dots to access nested properties
        const keys = key.split('.');
        let value = translations;
        // Navigate through the nested properties
        for (const k of keys) {
            if (value && typeof value === 'object' && k in value) {
                const nextValue = value[k];
                // Type narrowing to ensure value remains a Record<string, unknown> | string
                if (typeof nextValue === 'string' || (nextValue && typeof nextValue === 'object')) {
                    value = nextValue;
                }
                else {
                    return key; // Unexpected type, return the key itself
                }
            }
            else {
                return key; // Key not found, return the key itself
            }
        }
        // If the value is a string, replace parameters
        if (typeof value === 'string') {
            return Object.entries(params).reduce((str, [param, val]) => {
                return str.replace(new RegExp(`{${param}}`, 'g'), String(val));
            }, value);
        }
        return key; // Not a string, return the key
    };
    return t;
}
